export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; query: string; href?: string; external?: boolean }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'home',
      displayName: 'menu.home',
      meta: {
        icon: '',
        query: '',
      },
    },
    {
      name: 'programs',
      displayName: 'menu.residency',
      meta: {
        icon: '',
        query: 'residency',
      },
    },
    {
      name: 'programs',
      displayName: 'menu.citizenship',
      meta: {
        icon: '',
        query: 'citizenship',
      },
    },
    {
      name: 'news',
      displayName: 'menu.news',
      meta: {
        icon: '',
        query: '',
      },
    },
    {
      name: 'about-us',
      displayName: 'menu.about',
      meta: {
        icon: '',
        query: '',
      },
    },
    {
      name: 'partnership',
      displayName: 'menu.partnership',
      meta: {
        icon: '',
        query: '',
      },
    },
    {
      name: 'contact-us',
      displayName: 'menu.contact',
      meta: {
        icon: '',
        query: '',
      },
    },
  ] as INavigationRoute[],
}
